import { Component, inject, input, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { take, takeUntil, tap } from 'rxjs/operators';
import { loadCropFields } from 'src/app/tga/store/tga.actions';
import { getTgaCropYear, selectCropFieldById } from 'src/app/tga/store/tga.selectors';

import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@next/core-lib/i18n';
// eslint-disable-next-line max-len
import { SpecificFormHeaderSectionComponent } from '../../../components/questionnaire/form-header-section/specific-form-header-section/specific-form-header-section.component';
import { TgaCropFieldWithStatus } from '../../models/models';

@Component({
  selector: 'app-no-questions',
  template: `
  @if (questionnaireType() === 'generic') {
  <div>
    <h2 class="title">{{ title() }}</h2>
    <div class="margin">
      {{ 'TGA.Questionnaire.NoQuestionnaireMessage' | translate }}
    </div>
  </div>
} @else if (cropField$ && (cropField$ | async) != null) {
  <specific-form-header-section
    [title]="title()"
    [cropYear]="cropYear()!"
    [cropField]="(cropField$ | async)?.cropField"
  ></specific-form-header-section>
  <div class="margin">
    {{ 'TGA.Questionnaire.NoQuestionnaireMessage' | translate }}
  </div>
}`,
  styles: [
    `.title {
  font-size: 1.5em;
  font-weight: bold;
  color: #007c28;
  margin-bottom: 1rem;
}
.margin{
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
  font-style: italic;
}`,
  ],
  imports: [
    SpecificFormHeaderSectionComponent,
    AsyncPipe,
    TranslatePipe,
  ],
})
export class NoQuestionsComponent implements OnInit, OnDestroy {
  private readonly store = inject(Store);

  title = input.required<string>();
  questionnaireType = input<string | null>();
  cropFieldId = input<number | null>();
  cropYear = input<number | null>();
  cropField$: Observable<TgaCropFieldWithStatus | null> | undefined;
  private readonly destroy$ = new Subject<void>();

  ngOnInit(): void {
    if (this.cropFieldId()) {
      this.cropField$ = this.store.select(selectCropFieldById(this.cropFieldId() ?? null));
      this.cropField$.pipe(
        tap((cropfieldWithStatus) => {
          if (!cropfieldWithStatus) {
            this.store
              .select(getTgaCropYear)
              .pipe(take(1))
              .subscribe((cropYear) => {
                this.store.dispatch(loadCropFields({ cropYear: this.cropYear() ?? cropYear }));
              });
          }
        }),
        takeUntil(this.destroy$),
      ).subscribe();
    }
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
